export const APP_ROUTES = [
  'overview',
  'organisations',
  'pipeline',
  'reports',
  'opportunities',
  'tasks',
  'catalogue',
  'team',
  'onboarding',
  'xero',
  'migration',
  'audit',
  'administration',
] as const;

export type AppRoute = (typeof APP_ROUTES)[number];

/** A creation hint opens a draft only; record links always take priority. */
export function createIntentFromHash(hash: string, route: 'organisations' | 'opportunities') {
  const [page, query = ''] = hash.replace(/^#/, '').split('?');
  const params = new URLSearchParams(query);
  return (
    page === route &&
    params.get('create') === '1' &&
    !params.has('organisationId') &&
    !params.has('contactId') &&
    !params.has('opportunityId') &&
    !params.has('newForOrganisationId') &&
    !params.has('newContact') &&
    !params.has('newTask') &&
    !params.has('newActivity')
  );
}

export function routeFromHash(hash: string): AppRoute {
  const candidate = hash.replace(/^#/, '').split('?')[0];
  if (candidate === 'catalog') return 'catalogue';
  return APP_ROUTES.includes(candidate as AppRoute) ? (candidate as AppRoute) : 'overview';
}

export function publicOnboardingTokenFromHash(hash: string): string | undefined {
  const [route, query = ''] = hash.replace(/^#/, '').split('?');
  if (route !== 'onboarding-form') return undefined;
  const token = new URLSearchParams(query).get('token') ?? '';
  return token.length > 0 && token.length <= 256 ? token : undefined;
}
